import { graphql, readInlineData } from 'react-relay';

import {
    type getCreatorsAccordionTabs_storyTellingTab$data,
    type getCreatorsAccordionTabs_storyTellingTab$key,
} from './__generated__/getCreatorsAccordionTabs_storyTellingTab.graphql.ts';
import { isCreatorsAccordionTab } from './isCreatorsAccordionTab.ts';

const storyTellingTabFragment = graphql`
    fragment getCreatorsAccordionTabs_storyTellingTab on StoryTellingTab @inline {
        tabType
        contentHeader
        contentBodyText
    }
`;

export const readCreatorsAccordionTabData = (
    tab: getCreatorsAccordionTabs_storyTellingTab$key
): getCreatorsAccordionTabs_storyTellingTab$data => readInlineData(storyTellingTabFragment, tab);

export const getCreatorsAccordionTabs = <T extends getCreatorsAccordionTabs_storyTellingTab$key>(
    tabs: readonly (T | null | undefined)[] | null | undefined
): T[] =>
    (tabs ?? []).filter((tab): tab is T => {
        if (!tab) {
            return false;
        }

        const { tabType, contentHeader, contentBodyText } = readCreatorsAccordionTabData(tab);

        return isCreatorsAccordionTab(tabType) && !!(contentHeader || contentBodyText);
    });
